import { render, staticRenderFns } from "./TemperatureTab.vue?vue&type=template&id=06d4d900"
import script from "./TemperatureTab.vue?vue&type=script&lang=ts"
export * from "./TemperatureTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports